import { render, staticRenderFns } from "./widgetTrfDstIpTopn.vue?vue&type=template&id=f4659c2e&scoped=true&"
import script from "./widgetTrfDstIpTopn.vue?vue&type=script&lang=js&"
export * from "./widgetTrfDstIpTopn.vue?vue&type=script&lang=js&"
import style0 from "./widgetTrfDstIpTopn.vue?vue&type=style&index=0&id=f4659c2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4659c2e",
  null
  
)

export default component.exports